"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.pagination.step': 'Krok',
    'onboarding.pagination.step.1': 'Krok 1',
    'onboarding.pagination.navigation': 'Nawigacja Onboardingu',
};
